import { connect } from 'react-redux';
import StrukturUnit from '../../views/Settings/StrukturUnit.view';
import {
  getParamOptionsAcademics, getStudentOptions, getPeriodsOptions, getSchoolUnitsOptions, getSchoolUnitsManageOptions, getPrmPositionOption, getPrmPositionAdmOption
} from '../../states/thunks/options.thunk';
import { getDetailsPosition, updateDetailsPosition, postingPosition, getNotesUnposting, generateStructur } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    getStudentOptions: payload => dispatch(getStudentOptions(payload)),
    getPrmPositionOption: payload => dispatch(getPrmPositionOption(payload)),
    getPrmPositionAdmOption: payload => dispatch(getPrmPositionAdmOption(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    handleGetDetailsPosition: (payload, goback) => dispatch(getDetailsPosition(payload, goback)),
    handleUpdateDetailsPosition: (payload, goback) => dispatch(updateDetailsPosition(payload, goback)),
    handlePostingPosition: (payload, goback) => dispatch(postingPosition(payload, goback)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getNotesUnposting: payload => dispatch(getNotesUnposting(payload)),
    getSchoolUnitsManageOptions: payload => dispatch(getSchoolUnitsManageOptions(payload)),
    generateStructur: payload => dispatch(generateStructur(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StrukturUnit);
